import { useUI } from '@/context/ui'
import es from 'date-fns/locale/es'
import hi from 'date-fns/locale/hi'
import zhCN from 'date-fns/locale/zh-CN'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import Router from 'next/router'
import React, { useEffect } from 'react'
import ReactDatePicker, { ReactDatePickerProps, registerLocale } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import * as styles from './style'
dayjs.extend(relativeTime)
registerLocale('hi-IN', hi)
registerLocale('zh-CN', zhCN)
registerLocale('es-US', es)

const ScheduleCalendar: React.FC<ReactDatePickerProps> = (props) => {
  const router = Router
  const {
    state: { calendarSelectedDay, schedulePage },
    dispatch,
  } = useUI()
  const value = props.value || dayjs().format()
  const data = { ...props, value }

  useEffect(() => {
    dispatch({
      type: 'SET_CALENDAR_DATE',
      payload: dayjs(schedulePage.day).toDate(),
    })
  }, [schedulePage.day])

  const locale = router.locale === 'en-US' ? undefined : router.locale

  return (
    <div className={`${styles.picker} pb-sm`}>
      <ReactDatePicker
        key={dayjs(calendarSelectedDay).format('YYYYMM').toString()}
        {...data}
        focusSelectedMonth={true}
        highlightDates={[calendarSelectedDay]}
        open={true}
        selected={calendarSelectedDay}
        locale={locale}
      />
    </div>
  )
}

export default ScheduleCalendar
